/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";
import points_within_polygon from "@turf/points-within-polygon";
import circle from "@turf/circle";

/*COMPONENT*/
import Modal from "../common_modal/Modal";

/*REDUX*/
import { set_geojson_filtered } from "../../App/actions/toolboxActions";

/*PICTURE*/
import close from "../../Assets/svg/close.svg";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class TOOLBOX_DETAIL_RADIUS extends Component {
  state = {
    modal_warn: false,
    modal_warn_no_layer_selected: false,
  };

  toggle_warn = () => {
    this.setState({ modal_warn: !this.state.modal_warn });
  };

  toggle_warn_no_layer_selected = () => {
    this.setState({
      modal_warn_no_layer_selected: !this.state.modal_warn_no_layer_selected,
    });
  };

  on_filter = () => {
    const { layer_id, geo_layer_list } = this.props.layer;
    const { features_radius, features_area } = this.props.toolbox;

    const features_radius_polygon = features_radius.map((feature_point) => {
      const polygon = circle(
        feature_point,
        feature_point.properties.radius_km,
        {
          steps: 100,
          units: "kilometers",
          properties: feature_point.properties,
        }
      );
      return polygon;
    });
    const geojson_radius_polygon = {
      type: "FeatureCollection",
      features: [...features_radius_polygon, ...features_area],
    };
    const layer_object = geo_layer_list?.find(
      (item) => item?.geo_layer?._id === layer_id
    )?.geo_layer;
    const geojson_point = layer_object.geojson;
    const geojson_filtered = points_within_polygon(
      geojson_point,
      geojson_radius_polygon
    );
    const features_filtered = geojson_filtered.features;
    const body = {
      geo_layer_id: layer_id,
      features_filtered,
    };
    this.props.set_geojson_filtered(body);
  };

  on_reset = () => {
    const { layer_id, geo_layer_list } = this.props.layer;
    const layer_object = geo_layer_list?.find(
      (item) => item?.geo_layer?._id === layer_id
    )?.geo_layer;
    const features_filtered = layer_object?.geojson?.features || [];
    if (layer_id) {
      const body = {
        geo_layer_id: layer_id,
        features_filtered,
      };
      this.props.set_geojson_filtered(body);
    }
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const { modal_warn, modal_warn_no_layer_selected } = this.state;

    //global props
    const { features_radius } = this.props.toolbox;
    const { layer_id, geo_layer_list } = this.props.layer;

    //content
    const layer_object = geo_layer_list?.find(
      (item) => item?.geo_layer?._id === layer_id
    )?.geo_layer;
    const layer_type = layer_object?.type;
    const features = layer_object?.geojson_filtered?.features || [];

    const modal_warn_content = modal_warn && (
      <Modal modalSize="small" isOpen={modal_warn} onClose={this.toggle_warn}>
        <div className="box-body" id="box-body">
          <p className="text_bold">Draw radius first</p>
        </div>
      </Modal>
    );

    const modal_warn_no_layer_selected_content =
      modal_warn_no_layer_selected && (
        <Modal
          modalSize="small"
          isOpen={modal_warn_no_layer_selected}
          onClose={this.toggle_warn_no_layer_selected}
        >
          <div className="box-body" id="box-body">
            <p className="text_medium">
              {layer_type ? (
                <>
                  {
                    dict?.["The layer you selected is not Point but"]?.[
                      language
                    ]
                  }{" "}
                  <b>{layer_type}</b>.
                  <br />
                  <br />
                  {
                    dict?.["This tool is only for Point type layers."]?.[
                      language
                    ]
                  }
                </>
              ) : (
                <>{dict?.["Select one layer (point type) first"]?.[language]}</>
              )}
            </p>
          </div>
        </Modal>
      );

    return (
      <section className="container_light margin_bottom background_grey_light outline_black">
        {modal_warn_content}
        {modal_warn_no_layer_selected_content}
        <p className="text_bold">Radius</p>
        <p className="text_small">
          {`Create a buffer by radius

You can change the value of radius and clip your data with radius you create.
Only works with point type layers.`}
        </p>

        <section className="container_light background_white margin_bottom">
          <div className="badge_pill background_black">Radius</div> x{" "}
          <div className="badge_pill background_black margin_top">
            {layer_object?.name || "Belum pilih layer"}
          </div>
          <br />
        </section>
        <table className="full_width">
          <tbody>
            <tr>
              <td>
                <div className="text_small margin_right">
                  {features.length} item
                </div>
                {features_radius.length === 0 ? (
                  <button
                    className="button background_black"
                    onClick={this.toggle_warn}
                  >
                    {dict?.["Filter"]?.[language]}
                  </button>
                ) : layer_type !== "Point" ? (
                  <button
                    className="button background_black"
                    onClick={this.toggle_warn_no_layer_selected}
                  >
                    {dict?.["Filter"]?.[language]}
                  </button>
                ) : (
                  <button
                    className="button background_black"
                    onClick={this.on_filter}
                  >
                    {dict?.["Filter"]?.[language]}
                  </button>
                )}
              </td>
              <td className="text_right">
                <img
                  className="cursor_pointer"
                  alt="close"
                  src={close}
                  style={{ height: "20px" }}
                  onClick={this.on_reset}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  toolbox: state.toolbox,
});

export default connect(mapStateToProps, { set_geojson_filtered })(
  TOOLBOX_DETAIL_RADIUS
);
